module.exports = __webpack_public_path__ + "assets/fonts/EBGaramond-SemiBoldItalic.86b881a2.ttf";